/** Wrap bare markdown tables in site data-table markup (mirrors Guides::BodyRenderer). */
export function wrapGuideTables(root = document) {
  root.querySelectorAll("table").forEach((table) => {
    if (table.closest(".data-table-wrap")) return
    if (table.closest(".not-prose")) return

    table.classList.add("data-table")
    const wrap = document.createElement("div")
    wrap.className = "data-table-wrap my-6"
    table.parentNode.insertBefore(wrap, table)
    wrap.appendChild(table)
  })
}
